module.exports = __webpack_public_path__ + "static/media/blog_grid_7.f74ea274.jpg";